import TransitionWrapper from "../atoms/TransitionWrapper";
import KycForm from "../organisms/KycForm";
import { useSelector } from "react-redux";

const Kyc = () => {
  // const { kycVerified } = useSelector((state) => state.authReducer);
  return (
    <TransitionWrapper>
      <div className="bg-gray-100 w-full h-full p-6">
       
        <KycForm 
        //  kycVerified={kycVerified}
          />
        {/* {kycVerified ? (
          <div className="w-full h-screen bg-white round text-center py-72 rounded-xl">
            <h3 className="py-4 text-3xl font-semibold text-blue-800">
              KYC Already Completed !!
            </h3>
          </div>
        ) : (
          <KycForm />
        )} */}
      </div>
    </TransitionWrapper>
  );
};

export default Kyc;
